import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden">
      <div className="relative h-[75vh] md:h-[85vh]">
        <video
          autoPlay loop muted playsInline
          poster="/hero-poster-wedding.jpg"
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="hero-video"
        >
          <source src="/hero-mediterranean-wedding.mp4" type="video/mp4" />
        </video>

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

        {/* Content */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center z-10">
            <p className="text-white/80 text-xs tracking-[0.3em] uppercase mb-8 animate-fade-in-up" data-testid="hero-subtitle">
              Malta's Premium Bridal Magazine
            </p>

            <h1
              className="text-5xl md:text-7xl lg:text-8xl text-white mb-8 leading-[1.05] tracking-tight drop-shadow-lg animate-fade-in-up delay-100"
              style={{ fontFamily: '"Playfair Display", serif' }}
              data-testid="hero-heading"
            >
              Where "Yes"<br />Turns Into
              <span className="block mt-1" style={{ color: '#DE92A9' }}>"I Do"</span>
            </h1>

            <p className="text-white/85 text-base md:text-lg leading-relaxed mb-12 max-w-xl mx-auto drop-shadow-md animate-fade-in-up delay-200" data-testid="hero-description">
              Celebrating love stories and bringing wedding dreams to life across Malta.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up delay-300">
              <button
                onClick={() => navigate('/wedding-stories')}
                className="text-white px-10 py-4 text-xs tracking-[0.15em] font-semibold group inline-flex items-center justify-center gap-2 transition-all duration-300 hover:tracking-[0.2em]"
                style={{ backgroundColor: '#DE92A9' }}
                data-testid="hero-cta-stories"
              >
                EXPLORE WEDDING STORIES
                <ArrowRight className="group-hover:translate-x-1 transition-transform" size={16} />
              </button>
              <button
                onClick={() => navigate('/the-magazine')}
                className="border-2 border-white/70 text-white px-10 py-4 text-xs tracking-[0.15em] font-semibold group inline-flex items-center justify-center gap-2 transition-all duration-300 hover:bg-white/10"
                data-testid="hero-cta-magazine"
              >
                READ THE MAGAZINE
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
